<script setup lang="ts">
import ToggleComponent from 'frontend/ui/components/ToggleComponent.vue'
import { computed } from 'vue'

interface Props {
  isMultiSortEnabled?: boolean
  isInputEnabled?: boolean
  tooltipContent?: string
}
const props = withDefaults(defineProps<Props>(), {
  isMultiSortEnabled: false,
  isInputEnabled: true,
  tooltipContent: null,
})

interface Emits {
  (e: 'update:isMultiSortEnabled', value: boolean): void
}
const emit = defineEmits<Emits>()

const isMultiSortEnabledModel = computed<boolean>({
  get() {
    return props.isMultiSortEnabled
  },
  set(value: boolean) {
    emit('update:isMultiSortEnabled', value)
  },
})
</script>

<template>
  <div
    class="table-multi-sort-toggle-container"
    v-tooltip.options="{ title: props.tooltipContent }"
  >
    <div class="table-multi-sort-toggle" :class="{ 'is-disabled': !props.isInputEnabled }">
      <div class="name">Multi sort</div>
      <ToggleComponent v-model:isChecked="isMultiSortEnabledModel" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.table-multi-sort-toggle {
  display: flex;
  gap: 8px;
  margin-right: 16px;
  align-items: center;

  &.is-disabled {
    opacity: 0.4;
    pointer-events: none;
  }
}

.name {
  //font-weight: 600;
  //text-transform: uppercase;
  color: map.get(themeVariables.$colors, onSurface);
  font-size: 15px;
  white-space: nowrap;
}
</style>
